import { useQuery } from '@tanstack/react-query';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../lib/axios';
import { DuplicateBookingModel } from '../../../../features/activities/travellers/types';

export function useDuplicateBookingQuery(
  travellerIds: number[],
  checkInDate: string | undefined,
  checkOutDate: string | undefined,
  activityId: number | undefined
) {
  return useQuery({
    queryKey: [
      ActivityEndpoints.travellers.duplicateBooking(travellerIds, checkInDate!, checkOutDate!, activityId),
      travellerIds,
      checkInDate,
      checkOutDate
    ],
    retry: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
    gcTime: 1,
    queryFn: async () => {
      return (
        await getAxios().get<DuplicateBookingModel[]>(
          `${ActivityEndpoints.travellers.duplicateBooking(travellerIds, checkInDate!, checkOutDate!, activityId)}`
        )
      ).data;
    },
    enabled: !!checkInDate && !!checkOutDate && checkInDate.length > 0 && checkOutDate.length > 0
  });
}
